import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const get_Data_Good_Day = async (values) => {
    const res = await axios.post(
        `${API_URL}good-day-selection-rating-report/data-statistics`,
        values
    );
    return res;
};

export const get_Data_Good_Day_graphical = async (values) => {
    const res = await axios.post(
        `${API_URL}good-day-selection-rating-report/graphical-statistics`,
        values
    );
    return res;
};

export const get_Data_Good_Day_usage_graphical = async (values) => {
    const res = await axios.post(
        `${API_URL}good-day-selection-usage-report/graphical-statistics`,
        values
    );
    return res;
};

export const get_Data_Good_Day_usage_data = async (values) => {
    const res = await axios.post(
        `${API_URL}good-day-selection-usage-report/data-statistics`,
        values
    );
    return res;
};

export const get_getGoodDaySelectionWorkList = async (values) => {
    const res = await axios.post(`${API_URL}common/getGoodDaySelectionWorkList`, values);
    return res;
};
